import RecentlyViewedDeals from './RecentlyViewedDeals.component';

export default RecentlyViewedDeals;
